'use client';

import { datadogRum } from '@datadog/browser-rum';
import { TriangleAlert } from 'lucide-react';
import { Component, type ReactNode } from 'react';

import { isDatadogRumInitialized } from '@/auth-src/lib/datadog';

export const ERROR_MESSAGE =
  "Something went wrong. We've received the error and will work to fix it.";

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    if (isDatadogRumInitialized()) {
      datadogRum.addError(error, {
        componentStack: info.componentStack ?? undefined,
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex size-full flex-col items-center justify-center gap-3 text-red-600">
          <TriangleAlert className="size-10" />
          <p className="text-sm text-red-800">{ERROR_MESSAGE}</p>
        </div>
      );
    }

    return this.props.children;
  }
}
